import React from "react";
import { Accordion, Table } from "react-bootstrap";

const dataArray = [
  { abc: "qwer", genai: [] },
  { abc: "erre", genai: "nan" },
  {
    abc: "fggf",
    genai: [
      {
        name: "name1",
        committed: [
          { abc: "123", def: "345" },
          { abc: "123df", def: "34df5" }
        ],
        scaled: [{ fgh: "890", thd: "987" }]
      },
      {
        name: "name2",
        committed: [{ abc: "12df3", def: "3afd45" }],
        scaled: [
          { fgh: "89asdf0", thd: "98sadf7" },
          { fgh: "89af0", thd: "98df7" }
        ]
      }
    ]
  },
  {
    abc: "rgege",
    genai: [
      {
        name: "name1",
        committed: [
          { abc: "12sd3", def: "34sd5" },
          { abc: "12sd3df", def: "34dsdf5" }
        ],
        scaled: [{ fgh: "89sd0", thd: "9sd87" }]
      },
      {
        name: "name2",
        committed: [{ abc: "12df3as", def: "3ddsafd45" }],
        scaled: [
          { fgh: "89asdssdsdf0", thd: "98ssdadf7" },
          { fgh: "89sdaf0", thd: "98dsdf7" }
        ]
      }
    ]
  }
];

const safe = (v) =>
  v === null ||
  v === undefined ||
  String(v).toLowerCase() === "nan" ||
  v === "" ||
  v === "--"
    ? ""
    : v;

const labelMap = {
  abc: "GenAI",
  def: "Details",
  fgh: "Impact",
  thd: "Score"
};

const App = () => {
  const normalized = dataArray
    .filter((item) => item && item.abc)
    .map((block) => ({
      abc: block.abc,
      rows: Array.isArray(block.genai)
        ? block.genai.filter((g) => g && typeof g === "object")
        : []
    }));

  const hasData = (type) =>
    normalized.some((b) =>
      b.rows.some((g) => Array.isArray(g[type]) && g[type].length > 0)
    );

  const renderTable = (type) => {
    const cols =
      type === "committed" ? ["abc", "def"] : ["fgh", "thd"];

    return (
      <Table bordered striped hover size="sm">
        <thead>
          <tr>
            <th className="fw-medium">ABC</th>
            <th className="fw-medium">Name</th>
            {cols.map((c) => (
              <th key={c} className="fw-medium">
                {labelMap[c] || c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {normalized.map((block, bIdx) => {
            const validRows = block.rows.filter((entry) =>
              Array.isArray(entry[type]) && entry[type].length > 0
            );

            if (validRows.length === 0) return null;

            const abcRowCount = validRows.reduce(
              (sum, r) => sum + (r[type]?.length || 0),
              0
            );

            let abcUsed = false;

            return validRows.map((entry, entryIdx) => {
              const nameRows = entry[type] || [];
              const nameRowSpan = nameRows.length;
              let nameUsed = false;

              return nameRows.map((row, i) => (
                <tr key={`${bIdx}-${entryIdx}-${i}`}>
                  {/* ABC rowspan */}
                  {!abcUsed && (
                    <td
                      rowSpan={abcRowCount}
                      className="align-middle fw-bold"
                    >
                      {safe(block.abc)}
                    </td>
                  )}
                  {(abcUsed = true)}

                  {/* NAME rowspan */}
                  {!nameUsed && safe(entry.name) && (
                    <td rowSpan={nameRowSpan} className="align-middle">
                      {safe(entry.name)}
                    </td>
                  )}
                  {(nameUsed = true)}

                  {cols.map((c) => (
                    <td key={c}>{safe(row[c])}</td>
                  ))}
                </tr>
              ));
            });
          })}
        </tbody>
      </Table>
    );
  };

  return (
    <div className="container mt-4">
      <Accordion defaultActiveKey="0">
        {hasData("committed") && (
          <Accordion.Item eventKey="0">
            <Accordion.Header>Committed</Accordion.Header>
            <Accordion.Body>{renderTable("committed")}</Accordion.Body>
          </Accordion.Item>
        )}

        {hasData("scaled") && (
          <Accordion.Item eventKey="1">
            <Accordion.Header>Scaled</Accordion.Header>
            <Accordion.Body>{renderTable("scaled")}</Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
    </div>
  );
};

export default App;
